import { memo, useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';

const BasicPopup = memo(({ children, height = 27.75, width = 27.75, onPopupOutsideClick }) => {
  const containerStyle = useMemo(
    () => ({
      height: `${height}rem`,
      width: `${width}rem`,
    }),
    [height, width]
  );

  const handleOutsideClick = useCallback(() => {
    onPopupOutsideClick?.();
  }, [onPopupOutsideClick]);

  const handleContainerClick = useCallback(e => {
    e.stopPropagation();
  }, []);

  return (
    <div
      className="fixed inset-0 z-50 grid place-content-center bg-black/70 backdrop-blur-sm"
      onClick={handleOutsideClick}
    >
      <div
        className="bg-background relative rounded-lg shadow-2xl"
        style={containerStyle}
        onClick={handleContainerClick}
      >
        {children}
      </div>
    </div>
  );
});

BasicPopup.propTypes = {
  children: PropTypes.node,
  height: PropTypes.number,
  width: PropTypes.number,
  onPopupOutsideClick: PropTypes.func,
};

export default BasicPopup;
